import * as React from "react";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { GrafferNotifService } from "../../../application/domain/notifi-from-graffer/notif-from-graffer-service";
import { NotifFromGrafferType } from "../../../application/domain/notifi-from-graffer/notif-from-graffer";
import { Link } from "react-router-dom";
import { SettingR } from "../../pages/settings/route";

const BANNER_NOTICE_SUPPRESS = "BANNER_NOTICE_SUPPRESS";

export const BannerNotice: React.FC = () => {
  const [currentBannerNotice, setCurrentBannerNotice] = useState<
    NotifFromGrafferType | undefined
  >();
  const [suppressed, setSuppressed] = useState(
    Cookies.get(BANNER_NOTICE_SUPPRESS),
  );

  const checkBannerNotice = React.useCallback(async () => {
    const shouldDisplayNotice = await GrafferNotifService.fetchBannerNotice();
    if (shouldDisplayNotice) {
      setCurrentBannerNotice(shouldDisplayNotice);
    }
  }, [setCurrentBannerNotice]);

  useEffect(() => {
    checkBannerNotice();
  }, [checkBannerNotice]);

  if (!currentBannerNotice || currentBannerNotice.slug === suppressed) {
    return null;
  }
  return (
    <div
      className="pl-4 pt-2 pb-2 pr-4"
      style={{
        backgroundColor: "#fcf6cf",
      }}
    >
      <div className="columns is-vcentered is-mobile is-paddingless is-marginless">
        <div className="column is-paddingless">
          <p
            style={{
              paddingTop: "8px",
              paddingBottom: "8px",
            }}
            className="is-size-7"
          >
            {currentBannerNotice.title}
            <Link
              className="ml-2"
              to={SettingR.NotifFromGrafferDetail.link(
                currentBannerNotice.slug,
              )}
              onClick={() => {
                Cookies.set(BANNER_NOTICE_SUPPRESS, currentBannerNotice.slug);
                setSuppressed(currentBannerNotice.slug);
              }}
            >
              詳細を確認
            </Link>
          </p>
        </div>
        <div className="column is-narrow is-paddingless">
          <button
            className="delete"
            aria-label="delete"
            onClick={() => {
              Cookies.set(BANNER_NOTICE_SUPPRESS, currentBannerNotice.slug);
              setSuppressed(currentBannerNotice.slug);
            }}
          />
        </div>
      </div>
    </div>
  );
};
